export const TextTeaserGroupWidgetId = 'TextTeaserGroupWidget';

export enum TextTeaserGroupWidgetAttributes {
  TEXT_TEASER = 'textTeaser',
}
